import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import SavingsSummary from '../SavingsSummary';
import { trackCallButtonClick, trackAppDownloadClick } from '../../utils/tracking';

interface SuccessSlideProps {
  productType: ProductType;
  zipFlag: boolean | null;
  zipCode?: string;
  mongoId?: string;
  phone?: string;
}

/**
 * Slide di successo dopo l'invio del form
 */
const SuccessSlide: React.FC<SuccessSlideProps> = ({
  productType,
  zipFlag,
  zipCode,
  mongoId,
  phone,
}) => {

  const handleCallClick = () => {
    trackCallButtonClick();
  };

  const handleAppDownloadClick = () => {
    trackAppDownloadClick();
  };


  return (
    <div className={styles.successSlide}>
      <div className={styles.successHeader}>
        <div className={styles.successCheckmark}>✓</div>
      </div>

      <div className={styles.successCtaBar}>
        <a
          href="tel:00393476331490"
          className={styles.btnCallNow}
          onClick={handleCallClick}
        >
          Chiamaci Ora
        </a>
      </div>

      <h3 className={styles.successMainTitle}>
        Approfitta subito dei Bonus, ti chiamiamo a breve da un numero di
        cellulare.
      </h3>

      <p className={styles.successSubtitle}>
        Alternativamente puoi contattarci già tu cliccando su "Chiamaci Ora".
      </p>

      <SavingsSummary productType={productType} zipFlag={zipFlag} zipCode={zipCode} />

      {mongoId && (
        <a
          href={`https://app.enpal.it/login?payload=${btoa(phone || '')}`}
          className={styles.appCta}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleAppDownloadClick}
        >
          Scarica l'app per scoprire di più sui bonus
        </a>
      )}
    </div>
  );
};

export default SuccessSlide;

